module.exports = "<button class=\"btn\" (click)=\"setLabel(label)\">{{label | titlecase}}</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jlam2/impresocloud/www/client/src/app/shared/button/button.component.html
// module id = ../../../../../src/app/shared/button/button.component.html
// module chunks = main